/**
 * Moves the Activity tab to one of its sections: the subnav, the Overview's
 * flags and completion tiles, and Applications' "See … practice" all come
 * here. These are buttons, never bare "#…" links: the page's <base> tag
 * resolves a bare "#activity-writing" against the site root, so the
 * browser would leave the dashboard for the landing page.
 *
 * Scrolls smoothly unless the viewer asks for reduced motion, then moves
 * focus to the section's heading (tabIndex -1, ActivitySection) without a
 * second scroll, so keyboard and screen-reader users land where the page
 * did. `.td-act-section`'s scroll-margin-top keeps the title clear of the
 * sticky subnav.
 */
import { sectionAnchor, sectionTitleId } from '../ActivitySection';

const prefersReducedMotion = () => typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Sections that no longer have their own heading. Old links and bookmarks
// still name them; each lands on the block that now holds that content.
const MOVED_SECTIONS = {
  engagement: { anchor: sectionAnchor('overview'), title: sectionTitleId('overview') },
  chat: { anchor: 'td-act-chat', title: 'td-act-chat-title' },
};

/** Scrolls to the section `key` and focuses its heading; false when no such section is on the page. */
export function scrollToSection(key) {
  const moved = MOVED_SECTIONS[key];
  const anchorId = moved ? moved.anchor : sectionAnchor(key);
  const titleId = moved ? moved.title : sectionTitleId(key);
  const section = document.getElementById(anchorId);
  if (!section) return false;
  if (typeof section.scrollIntoView === 'function') {
    section.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }
  const heading = document.getElementById(titleId);
  if (heading) heading.focus({ preventScroll: true });
  return true;
}
